import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Form, Formik } from "formik";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { FcViewDetails } from "react-icons/fc";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import Footer from "../../../Components/Footer/footer";
import { SiScheduleByClient } from "../../../SchemaInfo/info";
import { SiScheduledSchema } from "../../../Schemas/Schedule siteInspection/scheduledSiteInspection";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import CustomInput from "../../../CustomComponent/custom_input";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import SimpleButton from "../../../Components/layouts/simple_button";

function SIschedulesBySales() {
  const navigate = useNavigate();
  let userData = useSelector((store) => store.login.user);
  const [initialValuesData, setInitialValuesData] =
    useState(SiScheduleByClient);
  const [loading, setLoading] = useState(false);
  const [extendDate, setExtendDate] = useState("");
  const [userSelectedSlots, setUserSelectedSlots] = useState([]);
  const [ordersDetails, setOrderDetails] = useState([]);
  const [fullyBookedDates, setFullyBookedDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [availableSlotsForSelectedDates, setAvailableSlotsForSelectedDates] =
    useState([]);
  const [slotsCount, setSlotsCount] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handelSubmitPatch = (values) => {
    values.orderId = selectedOrder.orderId;
    values.generatedBy = userData?.UserId;
    let data = { userSelectedSlots, values };
    if (slotsCount === 3) {
      setLoading(true);
      performRequest(
        "POST",
        `/bookSiteInspection/createBookSiteInspection/`,
        data
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Date Selected Successfully");
            navigate("/si-schedules");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
          window.location.reload();
        })
        .finally(() => setLoading(false));
    } else {
      Toast("error", "Please Select Any Three slots");
    }
  };

  const filteredOrders = ordersDetails?.filter((el) =>
    `${el.orderId} ${el.contactNumber} ${el.email}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0].split("-").reverse().join("-");
  };
  const getNext7Days = (startDateStr) => {
    // Convert "27-03-2025" to "2025-03-27" (YYYY-MM-DD) for Date object
    const [day, month, year] = startDateStr.split("-");
    const startDate = new Date(`${year}-${month}-${day}`);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + i);
      const formattedDate = date
        .toISOString()
        .split("T")[0]
        .split("-")
        .reverse()
        .join("-"); // Convert back to DD-MM-YYYY
      dates.push(formattedDate);
    }

    return dates;
  };

  useEffect(() => {
    performRequest("GET", `/bookSiteInspection/getFullyBookedDates/`)
      .then((res) => {
        if (res.status === 200) {
          setFullyBookedDates(res.data.fullyBookedDates);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/bookSiteInspection/getOrderUnbookedOrderIds/`)
      .then((res) => {
        if (res.status === 200) {
          setOrderDetails(res.data);
        }
      })
      .catch((err) => {
        Toast("error", err?.response?.data?.message);
      });
  }, []);

  const handleSelect = (order) => {
    setSelectedOrder(order);
    let date = formatDate(order.createdAt);
    setExtendDate(date);
    setInitialValuesData({
      name: order.fullName,
      email: order.email,
      contactNumber: order.contactNumber,
      orderId: order.orderId,
    });
    setSearchTerm(""); // Clear input after selection
    setIsOpen(false); // Close dropdown
  };

  const handleSlotSelect = (slot, date) => {
    setUserSelectedSlots((prevData) => {
      let newSlots = [...prevData];
      let existingDateIndex = newSlots.findIndex((d) => d.date === date);
      let totalSelectedSlots = prevData.reduce(
        (count, d) => count + d.slots.length,
        0
      );

      if (existingDateIndex !== -1) {
        let updatedSlots = [...newSlots[existingDateIndex].slots];
        let slotIndex = updatedSlots.findIndex((s) => s.slot === slot);

        if (slotIndex !== -1) {
          updatedSlots.splice(slotIndex, 1); // Remove slot
          newSlots[existingDateIndex] = {
            ...newSlots[existingDateIndex],
            slots: updatedSlots,
          };
          setSlotsCount((prev) => {
            const newCount = prev - 1;
            Toast("info", `${newCount} Remaining Slots`);
            return newCount;
          });
        } else {
          if (totalSelectedSlots < 3) {
            updatedSlots.push({ slot });
            newSlots[existingDateIndex] = {
              ...newSlots[existingDateIndex],
              slots: updatedSlots,
            };
            setSlotsCount((prev) => {
              const newCount = prev + 1;
              Toast("success", `${3 - newCount} Remaining Slots`);
              return newCount;
            });
          } else {
            Toast("error", "You have Selected Maximum Slots");
            return prevData;
          }
        }

        if (updatedSlots.length === 0) {
          newSlots.splice(existingDateIndex, 1);
        }
      } else {
        if (totalSelectedSlots < 3) {
          newSlots = [...prevData, { date, slots: [{ slot }] }];
          setSlotsCount((prev) => {
            const newCount = prev + 1;
            Toast("success", `${3 - newCount} Remaining Slots`);
            return newCount;
          });
        } else {
          Toast("error", "You have Selected Maximum Slots");
          return prevData;
        }
      }

      return [...newSlots];
    });
  };

  const handleRemoveSlot = (date, slot) => {
    setUserSelectedSlots((prevData) => {
      let updatedData = prevData
        .map((entry) =>
          entry.date === date
            ? { ...entry, slots: entry.slots.filter((s) => s.slot !== slot) }
            : entry
        )
        .filter((entry) => entry.slots.length > 0);

      setSlotsCount((prev) => prev - 1);

      return updatedData;
    });
  };

  const isDateDisabled = (date) => {
    const [dayE, monthE, yearE] = extendDate.split("-");
    const extendDateObj = new Date(`${yearE}-${monthE}-${dayE}`);

    const next7Days = getNext7Days(extendDate);

    const formattedDate = date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");

    // Disable if:
    return (
      date < extendDateObj || // All previous dates
      next7Days.includes(formattedDate) || // Next 7 days including extendDate
      date.getDay() === 0 ||
      date.getDay() === 6 || // Disable weekends (Sunday & Saturday)
      fullyBookedDates.includes(formattedDate) // Fully booked dates
    );
  };

  useEffect(() => {
    if (selectedDate) {
      performRequest(
        "GET",
        `/bookSiteInspection/getSiteInspectionScheduelsByDate/${selectedDate}`
      )
        .then((res) => {
          if (res.status === 200) {
            setAvailableSlotsForSelectedDates(res.data.availableSlots);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    } else {
      setAvailableSlotsForSelectedDates([]);
    }
  }, [selectedDate]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcViewDetails className="fs-2 me-1" />
                    Schedule Site Inspection
                  </h2>
                  <h4 className="text-muted">
                    Add Site Inspection Schedules Dates .
                  </h4>
                </div>

                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block gap-3">
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => navigate("/create-si-order")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 5l0 14" />
                        <path d="M5 12l14 0" />
                      </svg>
                      Create Order
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">Add Site Inspection Details</h2>
              </div>

              <Formik
                initialValues={initialValuesData}
                validationSchema={SiScheduledSchema}
                enableReinitialize
                onSubmit={handelSubmitPatch}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 required ">
                              Booking Orders
                            </label>
                            <div className="position-relative col-lg-9">
                              {/* Search Input */}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Order ID, Contact, or Email..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onFocus={() => setIsOpen(true)}
                                onBlur={() =>
                                  setTimeout(() => setIsOpen(false), 200)
                                } // Delay closing to allow selection
                              />

                              {/* Dropdown List (Fixed Positioning) */}
                              {isOpen && (
                                <ul
                                  className="list-group position-absolute w-100 mt-1 shadow bg-white border rounded overflow-auto"
                                  style={{ maxHeight: "200px", zIndex: 1050 }}
                                >
                                  {filteredOrders.length > 0 ? (
                                    filteredOrders.map((el, index) => (
                                      <li
                                        key={index}
                                        className="list-group-item list-group-item-action"
                                        onMouseDown={() => handleSelect(el)}
                                      >
                                        ContactNumber: {el.contactNumber} |
                                        Email: ({el.email}) | OrderId:{" "}
                                        {el.orderId}
                                      </li>
                                    ))
                                  ) : (
                                    <li className="list-group-item text-muted">
                                      No results found
                                    </li>
                                  )}
                                </ul>
                              )}

                              {/* Display Selected Order */}
                              {selectedOrder && (
                                <p className="mt-2 alert alert-info">
                                  <strong>Selected:</strong> ContactNumber:{" "}
                                  {selectedOrder.contactNumber} | OrderId:{" "}
                                  {selectedOrder.orderId} | Email:
                                  {selectedOrder.email}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Name */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Name</label>
                            <div className="col-lg-9">
                              {" "}
                              <CustomInput name="name" type="text" />
                              {props.touched.name && props.errors.name && (
                                <p className="text-danger">
                                  {props.errors.name}
                                </p>
                              )}{" "}
                            </div>
                          </div>

                          {/* Email */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Email</label>
                            <div className="col-lg-9">
                              <CustomInput name="email" type="text" />
                              {props.touched.email && props.errors.email && (
                                <p className="text-danger">
                                  {props.errors.email}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Contact Number */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Contact Number
                            </label>
                            <div className="col-lg-9">
                              <CustomInput name="contactNumber" type="text" />
                              {props.touched.contactNumber &&
                                props.errors.contactNumber && (
                                  <p className="text-danger">
                                    {props.errors.contactNumber}
                                  </p>
                                )}
                            </div>
                          </div>
                          <hr />
                          <div className="mb-3 row">
                            <label htmlFor="" className="form-label col-lg-3">
                              Chosen Slots
                            </label>
                            <div className=" col-lg-9">
                              <div className="card">
                                <div className="card-header text-center">
                                  <div className="col-4 form-label">
                                    {" "}
                                    Select Slots
                                  </div>{" "}
                                  <div className="col-4 form-label">
                                    Available: 3
                                  </div>{" "}
                                  <div className="col-4 form-label">
                                    Booked: {slotsCount}
                                  </div>
                                </div>
                                <div className="card-body">
                                  <div className="row row-deck">
                                    {userSelectedSlots.length > 0 ? (
                                      userSelectedSlots.map(
                                        (dateEntry, index) => (
                                          <div
                                            key={index}
                                            className="col-lg-4 col-md-6"
                                          >
                                            <div className="card my-1">
                                              <div className="card-body">
                                                <p className="card-text fw-bold">
                                                  Date: {dateEntry.date}
                                                </p>
                                                <div className="d-flex flex-wrap">
                                                  {dateEntry.slots.map(
                                                    (slotObj, slotIdx) => (
                                                      <span
                                                        key={slotIdx}
                                                        className="badge bg-blue-lt m-1 d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
                                                        style={{
                                                          cursor: "pointer",
                                                          fontSize: "0.9rem",
                                                        }}
                                                      >
                                                        {slotObj.slot}
                                                        <span
                                                          className="ms-2 text-red fw-bold"
                                                          onClick={() =>
                                                            handleRemoveSlot(
                                                              dateEntry.date,
                                                              slotObj.slot
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            marginLeft: "8px",
                                                            transition:
                                                              "color 0.3s",
                                                          }}
                                                          onMouseEnter={(e) =>
                                                            (e.target.style.color =
                                                              "#ff4d4d")
                                                          }
                                                          onMouseLeave={(e) =>
                                                            (e.target.style.color =
                                                              "white")
                                                          }
                                                        >
                                                          ✖
                                                        </span>
                                                      </span>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <p>You Haven't Selected any Slot</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Select Dates */}
                          <div className="mb-1 row">
                            <label className="col-lg-3 form-label required">
                              Instructions
                            </label>
                            <div className="col-lg-9">
                              <ol>
                                <li>
                                  You can select a maximum of three slots.
                                </li>
                                <li>
                                  For each new slot, you can select the new
                                  date.
                                </li>
                                <li>
                                  You can book three time slots for a single
                                  date or one time slot for each new date.
                                </li>
                                <li>
                                  After selecting a date, you'll see available
                                  time slots and can choose from them.
                                </li>
                              </ol>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Date</label>
                            <div className="col-lg-9">
                              <DatePicker
                                selected={
                                  props.values.date1
                                    ? new Date(
                                        props.values.date1
                                          .split("-")
                                          .reverse()
                                          .join("-")
                                      )
                                    : null
                                }
                                onChange={(date) => {
                                  if (date) {
                                    const formattedDate = date
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                      })
                                      .replace(/\//g, "-");
                                    props.setFieldValue("date1", formattedDate);
                                    setSelectedDate(formattedDate);
                                  }
                                }}
                                filterDate={(date) => {
                                  return !isDateDisabled(date);
                                }}
                                minDate={new Date()} // Disable past dates
                                className="form-control w-100"
                                wrapperClassName="w-100"
                                placeholderText={
                                  !extendDate
                                    ? "Please Select Order Booking"
                                    : "DD-MM-YYYY"
                                }
                                disabled={!extendDate ?? "true"}
                                dateFormat="dd-MM-yyyy"
                              />

                              {props.touched.date1 && props.errors.date1 && (
                                <p className="text-danger">
                                  {props.errors.date1}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="row mb-3">
                            <label className="form-label col-lg-3">Time</label>
                            <div className="col-lg-9">
                              <div className="card">
                                <div className="card-body">
                                  <div className="row text-center">
                                    {!props.values.date1 ? (
                                      <p> Please Select Date </p>
                                    ) : availableSlotsForSelectedDates?.length >
                                      0 ? (
                                      availableSlotsForSelectedDates?.map(
                                        (slot, index) => (
                                          <div key={index} className="col-md-3">
                                            <div
                                              className={`card my-1 ${
                                                userSelectedSlots.some(
                                                  (d) =>
                                                    d.date ===
                                                      props.values.date1 &&
                                                    d.slots.some(
                                                      (s) => s.slot === slot
                                                    )
                                                )
                                                  ? "bg-secondary text-white"
                                                  : ""
                                              }`}
                                              onClick={() =>
                                                handleSlotSelect(
                                                  slot,
                                                  props.values.date1
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                opacity: userSelectedSlots.some(
                                                  (d) =>
                                                    d.date ===
                                                      props.values.date1 &&
                                                    d.slots.some(
                                                      (s) => s.slot === slot
                                                    )
                                                )
                                                  ? 0.5
                                                  : 1,
                                              }}
                                            >
                                              <div className="card-body">
                                                <p className="card-text">
                                                  {slot}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <p>
                                        All Slots are booked, Choose Another
                                        Date
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Submit" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className="col-md-9 col-sm-12 py-2">
            <div className="btn-list justify-content-center">
              <div className="d-lg-none d-md-none mt-3 mb-3 d-flex flex-column gap-2 align-items-center">
                <button
                  className="btn btn-primary d-flex align-items-center w-100"
                  onClick={() => navigate("/create-si-order")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon me-1"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                  Create Order
                </button>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
}

export default SIschedulesBySales;
